import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  loading: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: '100vh',
    width: '100vw',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f3f3f3',
    zIndex: 15000,
    overflow: 'hidden',
    '& > span': {
      appearance: 'none',
      position: 'relative',
      width: '7%',
      minWidth: 70,
      aspectRatio: 1,
      borderRadius: 5,
      animation: 'flip2 2s infinite ease-in-out',
      backgroundColor: '#218683',
    },
    '& h2': {
      margin: '40px 0 0',
      fontSize: 26,
      color: '#324467',
    },
  },
});

export default function AppLoading() {
  const cls = useStyles();
  return (
    <div className={cls.loading}>
      <span />
      <h2>در حال بارگذاری ...</h2>
    </div>
  );
}
